<template>
  <div class="w-100 top-bar d-flex justify-content-between align-items-center">
    <router-link :to="{ name: 'StoneList' }" class="ml-4">
      <img src="../assets/images/logo.svg" class="logo" alt="StoneBox" />
    </router-link>
    <div class="mr-5 ">
      <!-- <button
        class="btn d-flex align-items-center mr-2"
        @click.prevent="goToUsersList()"
      > -->
      <div v-if="isLogged">
        <DropdownMenu
          :list_inputs="menu_btn"
          :css_styles="dropdown_menu_styles"
          @item-clicked="handleDropdownClick"
        >
          <template v-slot:header>
            <div class="d-flex align-items-center">
              <strong
                >{{ is_pt_br ? "Olá" : "Hello" }}, </strong
              >
              <span class="ml-2">{{ userName }}</span>
              <i class="icon icon-arrow_down ml-2"></i>
            </div>
          </template>
        </DropdownMenu>
      </div>
      <div v-else>
        <button @click.prevent="logout()" class="btn btn-sm border-whigt">
          <small class="my-account">{{is_pt_br ?  'Acessar minha conta' : 'Access my account'}}</small>
        </button>
      </div>
      <!-- </button> -->
    </div>
  </div>
</template>

<script>
import DropdownMenu from "./DropdownMenu.vue";

import auth from "../utils/auth";
import { mapGetters } from "vuex";
export default {
  name: "MainMenu",
  components: { DropdownMenu },
  data() {
    return {
      dropdown_menu_styles: {
        top: "2.6rem",
        right: "-0.3rem",
      },
      menu_btn: [
        { label: this.is_pt_br?  "Usuários" : 'Users', danger: false },
        { label: "Logout", danger: true },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["userName"]),
    isLogged() {
      return auth.authenticatedIn();
    },

    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  methods: {
    handleDropdownClick(index) {
      switch (index) {
        case 0:
          this.goToUsersList();
          break;
        case 1:
          this.logout();
          break;
        default:
          console.log("add essa função no dropdown");
      }
    },
    goToUsersList() {
      const now = this.$router.history.current.name;
      if (now !== "UsersList") this.$router.push({ name: "UsersList" });
    },
    logout() {
      auth.logout();
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss">
.border-whigt {
  border: 1px solid #f1f1f1 !important;
  border-radius: 8px !important;
}
.top-bar {
  height: 60px;
  display: flex;
  //   padding: 0.8em 2em;
  background-color: black;
  border-radius: 0 0 16px 16px;
  color: #ffffff !important;
  .my-account {
    font-size: 14px;
  }
  .btn {
    color: #ffffff !important;
    font-size: 22px;
  }
  .icon {
    background: #ffffff;
    height: 22px;
    width: 22px;
  }

  .logo {
    background: #f1f1f1;
    padding: 1px;
    border-radius: 10px;
    width: 40px;
    height: 40px;
  }
}
</style>
